export const GSTR3B_REPORT_REQUEST = 'GSTR3B_REPORT_REQUEST';
export const GSTR3B_REPORT_SUCCESS = 'GSTR3B_REPORT_SUCCESS';
export const GSTR3B_REPORT_FAILURE = 'GSTR3B_REPORT_FAILURE';